import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ApplicationState } from '../../../store';
import { useDefaultValues } from '../../../context/DefaultValueProvider';

function useCompanyDefaultValues() {
    const { companyMaster } = useSelector<
        ApplicationState,
        { companyMaster: Exclude<ApplicationState['companyMaster'], undefined> }
    >((state) => ({
        companyMaster: state.companyMaster!,
    }));
    const companies = companyMaster.responseCompanyMaster?.result_list ?? [];

    const { defaultValues, getDefaultValue, getDefaultValues } = useDefaultValues();

    const mappedDefaultValues = useMemo(() => {
        const availableCompanySIDMap = new Map(
            companies.map((company) => [company.sid, company])
        );

        return defaultValues.map((defaultValue) => {
            const companyName = availableCompanySIDMap.get(
                defaultValue.sid
            )?.company_name;

            return {
                ...defaultValue,
                company_name:
                    defaultValue.sid === '*'
                        ? '*'
                        : companyName
                        ? companyName
                        : '-',
            };
        });
    }, [companies, defaultValues]);

    return {
        mappedDefaultValues,
        getDefaultValue,
        getDefaultValues,
    };
}

export default useCompanyDefaultValues;
